import gql from 'graphql-tag';
import * as Apollo from '@apollo/client';
import * as Types from '../../../server/graphql/__generated.types';

import {
  ClipCommentListFragmentDoc,
  ClipCommentFragmentDoc,
  SectionCommentListFragmentDoc,
  SectionCommentFragmentDoc,
} from '../fragments.generated';

const defaultOptions = {} as const;
export type ClipCommentsQueryVariables = Types.Exact<{
  inputs: Types.GetClipCommentsInputs;
}>;

export type ClipCommentsQuery = {
  __typename?: 'Query';
  comments: {
    __typename?: 'ClipCommentsConnection';
    edges: Array<{
      __typename?: 'ClipCommentEdge';
      cursor: string;
      node: {
        __typename?: 'ClipComment';
        id: string;
        content: string;
        userId: string;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        clipId?: string | null;
        selfViewed: boolean;
        commentViews?: Array<{
          __typename?: 'CommentView';
          userId: string;
          viewedAt: string;
          viewed: boolean;
        }> | null;
      };
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      hasNextPage: boolean;
    };
  };
};

export type CreateClipCommentMutationVariables = Types.Exact<{
  inputs: Types.CreateClipCommentInputs;
}>;

export type CreateClipCommentMutation = {
  __typename?: 'Mutation';
  createClipComment: {
    __typename?: 'CreateClipCommentMutationResponse';
    code: string;
    success: boolean;
    message: string;
    comment?: {
      __typename?: 'ClipComment';
      id: string;
      content: string;
      userId: string;
      createdAt: string;
      updatedAt: string;
      deletedAt?: string | null;
      clipId?: string | null;
      selfViewed: boolean;
      commentViews?: Array<{
        __typename?: 'CommentView';
        userId: string;
        viewedAt: string;
        viewed: boolean;
      }> | null;
    } | null;
  };
};

export type UpdateClipCommentMutationVariables = Types.Exact<{
  inputs: Types.UpdateClipCommentInputs;
}>;

export type UpdateClipCommentMutation = {
  __typename?: 'Mutation';
  updateClipComment: {
    __typename?: 'UpdateClipCommentMutationResponse';
    code: string;
    success: boolean;
    message: string;
    comment?: {
      __typename?: 'ClipComment';
      id: string;
      content: string;
      userId: string;
      createdAt: string;
      updatedAt: string;
      deletedAt?: string | null;
      clipId?: string | null;
      selfViewed: boolean;
      commentViews?: Array<{
        __typename?: 'CommentView';
        userId: string;
        viewedAt: string;
        viewed: boolean;
      }> | null;
    } | null;
  };
};

export type DeleteClipCommentMutationVariables = Types.Exact<{
  inputs: Types.DeleteClipCommentInputs;
}>;

export type DeleteClipCommentMutation = {
  __typename?: 'Mutation';
  deleteClipComment: {
    __typename?: 'DeleteCommentMutationResponse';
    code: string;
    success: boolean;
    message: string;
    commentId?: string | null;
  };
};

export type MarkClipCommentAsViewedMutationVariables = Types.Exact<{
  inputs: Types.MarkClipCommentAsViewedInputs;
}>;

export type MarkClipCommentAsViewedMutation = {
  __typename?: 'Mutation';
  markClipCommentAsViewed: {
    __typename?: 'MarkCommentAsViewedMutationResponse';
    code: string;
    success: boolean;
    message: string;
  };
};

export type MarkClipCommentAsUnviewedMutationVariables = Types.Exact<{
  inputs: Types.MarkClipCommentAsUnviewedInputs;
}>;

export type MarkClipCommentAsUnviewedMutation = {
  __typename?: 'Mutation';
  markClipCommentAsUnviewed: {
    __typename?: 'MarkCommentAsUnviewedMutationResponse';
    code: string;
    success: boolean;
    message: string;
  };
};

export type MarkAllClipCommentsAsViewedMutationVariables = Types.Exact<{
  inputs: Types.MarkAllClipCommentsAsViewedInputs;
}>;

export type MarkAllClipCommentsAsViewedMutation = {
  __typename?: 'Mutation';
  markAllClipCommentsAsViewed: {
    __typename?: 'MarkAllCommentsAsViewedMutationResponse';
    code: string;
    success: boolean;
    message: string;
  };
};

export type SectionCommentsQueryVariables = Types.Exact<{
  inputs: Types.GetSectionCommentsInputs;
}>;

export type SectionCommentsQuery = {
  __typename?: 'Query';
  sectionComments: {
    __typename?: 'SectionCommentsConnection';
    edges: Array<{
      __typename?: 'SectionCommentEdge';
      cursor: string;
      node: {
        __typename?: 'SectionComment';
        id: string;
        content: string;
        userId: string;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        sectionId?: string | null;
        selfViewed: boolean;
        commentViews?: Array<{
          __typename?: 'CommentView';
          userId: string;
          viewedAt: string;
          viewed: boolean;
        }> | null;
      };
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      hasNextPage: boolean;
    };
  };
};

export type CreateSectionCommentMutationVariables = Types.Exact<{
  inputs: Types.CreateSectionCommentInputs;
}>;

export type CreateSectionCommentMutation = {
  __typename?: 'Mutation';
  createSectionComment: {
    __typename?: 'CreateSectionCommentMutationResponse';
    code: string;
    success: boolean;
    message: string;
    comment?: {
      __typename?: 'SectionComment';
      id: string;
      content: string;
      userId: string;
      createdAt: string;
      updatedAt: string;
      deletedAt?: string | null;
      sectionId?: string | null;
      selfViewed: boolean;
      commentViews?: Array<{
        __typename?: 'CommentView';
        userId: string;
        viewedAt: string;
        viewed: boolean;
      }> | null;
    } | null;
  };
};

export type UpdateSectionCommentMutationVariables = Types.Exact<{
  inputs: Types.UpdateSectionCommentInputs;
}>;

export type UpdateSectionCommentMutation = {
  __typename?: 'Mutation';
  updateSectionComment: {
    __typename?: 'UpdateSectionCommentMutationResponse';
    code: string;
    success: boolean;
    message: string;
    comment?: {
      __typename?: 'SectionComment';
      id: string;
      content: string;
      userId: string;
      createdAt: string;
      updatedAt: string;
      deletedAt?: string | null;
      sectionId?: string | null;
      selfViewed: boolean;
      commentViews?: Array<{
        __typename?: 'CommentView';
        userId: string;
        viewedAt: string;
        viewed: boolean;
      }> | null;
    } | null;
  };
};

export type DeleteSectionCommentMutationVariables = Types.Exact<{
  inputs: Types.DeleteSectionCommentInputs;
}>;

export type DeleteSectionCommentMutation = {
  __typename?: 'Mutation';
  deleteSectionComment: {
    __typename?: 'DeleteCommentMutationResponse';
    code: string;
    success: boolean;
    message: string;
    commentId?: string | null;
  };
};

export type MarkSectionCommentAsViewedMutationVariables = Types.Exact<{
  inputs: Types.MarkSectionCommentAsViewedInputs;
}>;

export type MarkSectionCommentAsViewedMutation = {
  __typename?: 'Mutation';
  markSectionCommentAsViewed: {
    __typename?: 'MarkCommentAsViewedMutationResponse';
    code: string;
    success: boolean;
    message: string;
  };
};

export type MarkSectionCommentAsUnviewedMutationVariables = Types.Exact<{
  inputs: Types.MarkSectionCommentAsUnviewedInputs;
}>;

export type MarkSectionCommentAsUnviewedMutation = {
  __typename?: 'Mutation';
  markSectionCommentAsUnviewed: {
    __typename?: 'MarkCommentAsUnviewedMutationResponse';
    code: string;
    success: boolean;
    message: string;
  };
};

export type MarkAllSectionCommentsAsViewedMutationVariables = Types.Exact<{
  inputs: Types.MarkAllSectionCommentsAsViewedInputs;
}>;

export type MarkAllSectionCommentsAsViewedMutation = {
  __typename?: 'Mutation';
  markAllSectionCommentsAsViewed: {
    __typename?: 'MarkAllCommentsAsViewedMutationResponse';
    code: string;
    success: boolean;
    message: string;
  };
};

export const ClipCommentsDocument = gql`
  query ClipComments($inputs: GetClipCommentsInputs!) {
    comments: clipComments(inputs: $inputs) {
      ...ClipCommentListFragment
    }
  }
  ${ClipCommentListFragmentDoc}
`;

/**
 * __useClipCommentsQuery__
 *
 * To run a query within a React component, call `useClipCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClipCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClipCommentsQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useClipCommentsQuery(
  baseOptions: Apollo.QueryHookOptions<ClipCommentsQuery, ClipCommentsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ClipCommentsQuery, ClipCommentsQueryVariables>(
    ClipCommentsDocument,
    options
  );
}
export function useClipCommentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ClipCommentsQuery, ClipCommentsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ClipCommentsQuery, ClipCommentsQueryVariables>(
    ClipCommentsDocument,
    options
  );
}
export type ClipCommentsQueryHookResult = ReturnType<typeof useClipCommentsQuery>;
export type ClipCommentsLazyQueryHookResult = ReturnType<typeof useClipCommentsLazyQuery>;
export type ClipCommentsQueryResult = Apollo.QueryResult<
  ClipCommentsQuery,
  ClipCommentsQueryVariables
>;
export const CreateClipCommentDocument = gql`
  mutation CreateClipComment($inputs: CreateClipCommentInputs!) {
    createClipComment(inputs: $inputs) {
      code
      success
      message
      comment {
        ...ClipCommentFragment
      }
    }
  }
  ${ClipCommentFragmentDoc}
`;
export type CreateClipCommentMutationFn = Apollo.MutationFunction<
  CreateClipCommentMutation,
  CreateClipCommentMutationVariables
>;

/**
 * __useCreateClipCommentMutation__
 *
 * To run a mutation, you first call `useCreateClipCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClipCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClipCommentMutation, { data, loading, error }] = useCreateClipCommentMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateClipCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateClipCommentMutation,
    CreateClipCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateClipCommentMutation,
    CreateClipCommentMutationVariables
  >(CreateClipCommentDocument, options);
}
export type CreateClipCommentMutationHookResult = ReturnType<
  typeof useCreateClipCommentMutation
>;
export type CreateClipCommentMutationResult =
  Apollo.MutationResult<CreateClipCommentMutation>;
export type CreateClipCommentMutationOptions = Apollo.BaseMutationOptions<
  CreateClipCommentMutation,
  CreateClipCommentMutationVariables
>;
export const UpdateClipCommentDocument = gql`
  mutation UpdateClipComment($inputs: UpdateClipCommentInputs!) {
    updateClipComment(inputs: $inputs) {
      code
      success
      message
      comment {
        ...ClipCommentFragment
      }
    }
  }
  ${ClipCommentFragmentDoc}
`;
export type UpdateClipCommentMutationFn = Apollo.MutationFunction<
  UpdateClipCommentMutation,
  UpdateClipCommentMutationVariables
>;

/**
 * __useUpdateClipCommentMutation__
 *
 * To run a mutation, you first call `useUpdateClipCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClipCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClipCommentMutation, { data, loading, error }] = useUpdateClipCommentMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateClipCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateClipCommentMutation,
    UpdateClipCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateClipCommentMutation,
    UpdateClipCommentMutationVariables
  >(UpdateClipCommentDocument, options);
}
export type UpdateClipCommentMutationHookResult = ReturnType<
  typeof useUpdateClipCommentMutation
>;
export type UpdateClipCommentMutationResult =
  Apollo.MutationResult<UpdateClipCommentMutation>;
export type UpdateClipCommentMutationOptions = Apollo.BaseMutationOptions<
  UpdateClipCommentMutation,
  UpdateClipCommentMutationVariables
>;
export const DeleteClipCommentDocument = gql`
  mutation DeleteClipComment($inputs: DeleteClipCommentInputs!) {
    deleteClipComment(inputs: $inputs) {
      code
      success
      message
      commentId
    }
  }
`;
export type DeleteClipCommentMutationFn = Apollo.MutationFunction<
  DeleteClipCommentMutation,
  DeleteClipCommentMutationVariables
>;

/**
 * __useDeleteClipCommentMutation__
 *
 * To run a mutation, you first call `useDeleteClipCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClipCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClipCommentMutation, { data, loading, error }] = useDeleteClipCommentMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useDeleteClipCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteClipCommentMutation,
    DeleteClipCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteClipCommentMutation,
    DeleteClipCommentMutationVariables
  >(DeleteClipCommentDocument, options);
}
export type DeleteClipCommentMutationHookResult = ReturnType<
  typeof useDeleteClipCommentMutation
>;
export type DeleteClipCommentMutationResult =
  Apollo.MutationResult<DeleteClipCommentMutation>;
export type DeleteClipCommentMutationOptions = Apollo.BaseMutationOptions<
  DeleteClipCommentMutation,
  DeleteClipCommentMutationVariables
>;
export const MarkClipCommentAsViewedDocument = gql`
  mutation MarkClipCommentAsViewed($inputs: MarkClipCommentAsViewedInputs!) {
    markClipCommentAsViewed(inputs: $inputs) {
      code
      success
      message
    }
  }
`;
export type MarkClipCommentAsViewedMutationFn = Apollo.MutationFunction<
  MarkClipCommentAsViewedMutation,
  MarkClipCommentAsViewedMutationVariables
>;

/**
 * __useMarkClipCommentAsViewedMutation__
 *
 * To run a mutation, you first call `useMarkClipCommentAsViewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkClipCommentAsViewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markClipCommentAsViewedMutation, { data, loading, error }] = useMarkClipCommentAsViewedMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useMarkClipCommentAsViewedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkClipCommentAsViewedMutation,
    MarkClipCommentAsViewedMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MarkClipCommentAsViewedMutation,
    MarkClipCommentAsViewedMutationVariables
  >(MarkClipCommentAsViewedDocument, options);
}
export type MarkClipCommentAsViewedMutationHookResult = ReturnType<
  typeof useMarkClipCommentAsViewedMutation
>;
export type MarkClipCommentAsViewedMutationResult =
  Apollo.MutationResult<MarkClipCommentAsViewedMutation>;
export type MarkClipCommentAsViewedMutationOptions = Apollo.BaseMutationOptions<
  MarkClipCommentAsViewedMutation,
  MarkClipCommentAsViewedMutationVariables
>;
export const MarkClipCommentAsUnviewedDocument = gql`
  mutation MarkClipCommentAsUnviewed($inputs: MarkClipCommentAsUnviewedInputs!) {
    markClipCommentAsUnviewed(inputs: $inputs) {
      code
      success
      message
    }
  }
`;
export type MarkClipCommentAsUnviewedMutationFn = Apollo.MutationFunction<
  MarkClipCommentAsUnviewedMutation,
  MarkClipCommentAsUnviewedMutationVariables
>;

/**
 * __useMarkClipCommentAsUnviewedMutation__
 *
 * To run a mutation, you first call `useMarkClipCommentAsUnviewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkClipCommentAsUnviewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markClipCommentAsUnviewedMutation, { data, loading, error }] = useMarkClipCommentAsUnviewedMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useMarkClipCommentAsUnviewedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkClipCommentAsUnviewedMutation,
    MarkClipCommentAsUnviewedMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MarkClipCommentAsUnviewedMutation,
    MarkClipCommentAsUnviewedMutationVariables
  >(MarkClipCommentAsUnviewedDocument, options);
}
export type MarkClipCommentAsUnviewedMutationHookResult = ReturnType<
  typeof useMarkClipCommentAsUnviewedMutation
>;
export type MarkClipCommentAsUnviewedMutationResult =
  Apollo.MutationResult<MarkClipCommentAsUnviewedMutation>;
export type MarkClipCommentAsUnviewedMutationOptions = Apollo.BaseMutationOptions<
  MarkClipCommentAsUnviewedMutation,
  MarkClipCommentAsUnviewedMutationVariables
>;
export const MarkAllClipCommentsAsViewedDocument = gql`
  mutation MarkAllClipCommentsAsViewed($inputs: MarkAllClipCommentsAsViewedInputs!) {
    markAllClipCommentsAsViewed(inputs: $inputs) {
      code
      success
      message
    }
  }
`;
export type MarkAllClipCommentsAsViewedMutationFn = Apollo.MutationFunction<
  MarkAllClipCommentsAsViewedMutation,
  MarkAllClipCommentsAsViewedMutationVariables
>;

/**
 * __useMarkAllClipCommentsAsViewedMutation__
 *
 * To run a mutation, you first call `useMarkAllClipCommentsAsViewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllClipCommentsAsViewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllClipCommentsAsViewedMutation, { data, loading, error }] = useMarkAllClipCommentsAsViewedMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useMarkAllClipCommentsAsViewedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkAllClipCommentsAsViewedMutation,
    MarkAllClipCommentsAsViewedMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MarkAllClipCommentsAsViewedMutation,
    MarkAllClipCommentsAsViewedMutationVariables
  >(MarkAllClipCommentsAsViewedDocument, options);
}
export type MarkAllClipCommentsAsViewedMutationHookResult = ReturnType<
  typeof useMarkAllClipCommentsAsViewedMutation
>;
export type MarkAllClipCommentsAsViewedMutationResult =
  Apollo.MutationResult<MarkAllClipCommentsAsViewedMutation>;
export type MarkAllClipCommentsAsViewedMutationOptions = Apollo.BaseMutationOptions<
  MarkAllClipCommentsAsViewedMutation,
  MarkAllClipCommentsAsViewedMutationVariables
>;
export const SectionCommentsDocument = gql`
  query SectionComments($inputs: GetSectionCommentsInputs!) {
    sectionComments(inputs: $inputs) {
      ...SectionCommentListFragment
    }
  }
  ${SectionCommentListFragmentDoc}
`;

/**
 * __useSectionCommentsQuery__
 *
 * To run a query within a React component, call `useSectionCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSectionCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSectionCommentsQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useSectionCommentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    SectionCommentsQuery,
    SectionCommentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SectionCommentsQuery, SectionCommentsQueryVariables>(
    SectionCommentsDocument,
    options
  );
}
export function useSectionCommentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SectionCommentsQuery,
    SectionCommentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SectionCommentsQuery, SectionCommentsQueryVariables>(
    SectionCommentsDocument,
    options
  );
}
export type SectionCommentsQueryHookResult = ReturnType<typeof useSectionCommentsQuery>;
export type SectionCommentsLazyQueryHookResult = ReturnType<
  typeof useSectionCommentsLazyQuery
>;
export type SectionCommentsQueryResult = Apollo.QueryResult<
  SectionCommentsQuery,
  SectionCommentsQueryVariables
>;
export const CreateSectionCommentDocument = gql`
  mutation CreateSectionComment($inputs: CreateSectionCommentInputs!) {
    createSectionComment(inputs: $inputs) {
      code
      success
      message
      comment {
        ...SectionCommentFragment
      }
    }
  }
  ${SectionCommentFragmentDoc}
`;
export type CreateSectionCommentMutationFn = Apollo.MutationFunction<
  CreateSectionCommentMutation,
  CreateSectionCommentMutationVariables
>;

/**
 * __useCreateSectionCommentMutation__
 *
 * To run a mutation, you first call `useCreateSectionCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSectionCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSectionCommentMutation, { data, loading, error }] = useCreateSectionCommentMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateSectionCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSectionCommentMutation,
    CreateSectionCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateSectionCommentMutation,
    CreateSectionCommentMutationVariables
  >(CreateSectionCommentDocument, options);
}
export type CreateSectionCommentMutationHookResult = ReturnType<
  typeof useCreateSectionCommentMutation
>;
export type CreateSectionCommentMutationResult =
  Apollo.MutationResult<CreateSectionCommentMutation>;
export type CreateSectionCommentMutationOptions = Apollo.BaseMutationOptions<
  CreateSectionCommentMutation,
  CreateSectionCommentMutationVariables
>;
export const UpdateSectionCommentDocument = gql`
  mutation UpdateSectionComment($inputs: UpdateSectionCommentInputs!) {
    updateSectionComment(inputs: $inputs) {
      code
      success
      message
      comment {
        ...SectionCommentFragment
      }
    }
  }
  ${SectionCommentFragmentDoc}
`;
export type UpdateSectionCommentMutationFn = Apollo.MutationFunction<
  UpdateSectionCommentMutation,
  UpdateSectionCommentMutationVariables
>;

/**
 * __useUpdateSectionCommentMutation__
 *
 * To run a mutation, you first call `useUpdateSectionCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSectionCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSectionCommentMutation, { data, loading, error }] = useUpdateSectionCommentMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateSectionCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSectionCommentMutation,
    UpdateSectionCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateSectionCommentMutation,
    UpdateSectionCommentMutationVariables
  >(UpdateSectionCommentDocument, options);
}
export type UpdateSectionCommentMutationHookResult = ReturnType<
  typeof useUpdateSectionCommentMutation
>;
export type UpdateSectionCommentMutationResult =
  Apollo.MutationResult<UpdateSectionCommentMutation>;
export type UpdateSectionCommentMutationOptions = Apollo.BaseMutationOptions<
  UpdateSectionCommentMutation,
  UpdateSectionCommentMutationVariables
>;
export const DeleteSectionCommentDocument = gql`
  mutation DeleteSectionComment($inputs: DeleteSectionCommentInputs!) {
    deleteSectionComment(inputs: $inputs) {
      code
      success
      message
      commentId
    }
  }
`;
export type DeleteSectionCommentMutationFn = Apollo.MutationFunction<
  DeleteSectionCommentMutation,
  DeleteSectionCommentMutationVariables
>;

/**
 * __useDeleteSectionCommentMutation__
 *
 * To run a mutation, you first call `useDeleteSectionCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSectionCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSectionCommentMutation, { data, loading, error }] = useDeleteSectionCommentMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useDeleteSectionCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteSectionCommentMutation,
    DeleteSectionCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteSectionCommentMutation,
    DeleteSectionCommentMutationVariables
  >(DeleteSectionCommentDocument, options);
}
export type DeleteSectionCommentMutationHookResult = ReturnType<
  typeof useDeleteSectionCommentMutation
>;
export type DeleteSectionCommentMutationResult =
  Apollo.MutationResult<DeleteSectionCommentMutation>;
export type DeleteSectionCommentMutationOptions = Apollo.BaseMutationOptions<
  DeleteSectionCommentMutation,
  DeleteSectionCommentMutationVariables
>;
export const MarkSectionCommentAsViewedDocument = gql`
  mutation MarkSectionCommentAsViewed($inputs: MarkSectionCommentAsViewedInputs!) {
    markSectionCommentAsViewed(inputs: $inputs) {
      code
      success
      message
    }
  }
`;
export type MarkSectionCommentAsViewedMutationFn = Apollo.MutationFunction<
  MarkSectionCommentAsViewedMutation,
  MarkSectionCommentAsViewedMutationVariables
>;

/**
 * __useMarkSectionCommentAsViewedMutation__
 *
 * To run a mutation, you first call `useMarkSectionCommentAsViewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkSectionCommentAsViewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markSectionCommentAsViewedMutation, { data, loading, error }] = useMarkSectionCommentAsViewedMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useMarkSectionCommentAsViewedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkSectionCommentAsViewedMutation,
    MarkSectionCommentAsViewedMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MarkSectionCommentAsViewedMutation,
    MarkSectionCommentAsViewedMutationVariables
  >(MarkSectionCommentAsViewedDocument, options);
}
export type MarkSectionCommentAsViewedMutationHookResult = ReturnType<
  typeof useMarkSectionCommentAsViewedMutation
>;
export type MarkSectionCommentAsViewedMutationResult =
  Apollo.MutationResult<MarkSectionCommentAsViewedMutation>;
export type MarkSectionCommentAsViewedMutationOptions = Apollo.BaseMutationOptions<
  MarkSectionCommentAsViewedMutation,
  MarkSectionCommentAsViewedMutationVariables
>;
export const MarkSectionCommentAsUnviewedDocument = gql`
  mutation MarkSectionCommentAsUnviewed($inputs: MarkSectionCommentAsUnviewedInputs!) {
    markSectionCommentAsUnviewed(inputs: $inputs) {
      code
      success
      message
    }
  }
`;
export type MarkSectionCommentAsUnviewedMutationFn = Apollo.MutationFunction<
  MarkSectionCommentAsUnviewedMutation,
  MarkSectionCommentAsUnviewedMutationVariables
>;

/**
 * __useMarkSectionCommentAsUnviewedMutation__
 *
 * To run a mutation, you first call `useMarkSectionCommentAsUnviewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkSectionCommentAsUnviewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markSectionCommentAsUnviewedMutation, { data, loading, error }] = useMarkSectionCommentAsUnviewedMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useMarkSectionCommentAsUnviewedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkSectionCommentAsUnviewedMutation,
    MarkSectionCommentAsUnviewedMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MarkSectionCommentAsUnviewedMutation,
    MarkSectionCommentAsUnviewedMutationVariables
  >(MarkSectionCommentAsUnviewedDocument, options);
}
export type MarkSectionCommentAsUnviewedMutationHookResult = ReturnType<
  typeof useMarkSectionCommentAsUnviewedMutation
>;
export type MarkSectionCommentAsUnviewedMutationResult =
  Apollo.MutationResult<MarkSectionCommentAsUnviewedMutation>;
export type MarkSectionCommentAsUnviewedMutationOptions = Apollo.BaseMutationOptions<
  MarkSectionCommentAsUnviewedMutation,
  MarkSectionCommentAsUnviewedMutationVariables
>;
export const MarkAllSectionCommentsAsViewedDocument = gql`
  mutation MarkAllSectionCommentsAsViewed(
    $inputs: MarkAllSectionCommentsAsViewedInputs!
  ) {
    markAllSectionCommentsAsViewed(inputs: $inputs) {
      code
      success
      message
    }
  }
`;
export type MarkAllSectionCommentsAsViewedMutationFn = Apollo.MutationFunction<
  MarkAllSectionCommentsAsViewedMutation,
  MarkAllSectionCommentsAsViewedMutationVariables
>;

/**
 * __useMarkAllSectionCommentsAsViewedMutation__
 *
 * To run a mutation, you first call `useMarkAllSectionCommentsAsViewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllSectionCommentsAsViewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllSectionCommentsAsViewedMutation, { data, loading, error }] = useMarkAllSectionCommentsAsViewedMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useMarkAllSectionCommentsAsViewedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkAllSectionCommentsAsViewedMutation,
    MarkAllSectionCommentsAsViewedMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MarkAllSectionCommentsAsViewedMutation,
    MarkAllSectionCommentsAsViewedMutationVariables
  >(MarkAllSectionCommentsAsViewedDocument, options);
}
export type MarkAllSectionCommentsAsViewedMutationHookResult = ReturnType<
  typeof useMarkAllSectionCommentsAsViewedMutation
>;
export type MarkAllSectionCommentsAsViewedMutationResult =
  Apollo.MutationResult<MarkAllSectionCommentsAsViewedMutation>;
export type MarkAllSectionCommentsAsViewedMutationOptions = Apollo.BaseMutationOptions<
  MarkAllSectionCommentsAsViewedMutation,
  MarkAllSectionCommentsAsViewedMutationVariables
>;
